<template>
  <span
    class="workflow-node-cost"
    :title="$t('workflowNodeCost.title')"
    draggable="false"
  >
    {{ label }}
  </span>
</template>

<script>
const FLAT_COST_TYPE = 'flat'
const TIME_BASED_COST_TYPE = 'time_based'

const DEFAULT_COST = { type: FLAT_COST_TYPE, units: 1 }
const COST_OVERRIDES = {
  router: { type: FLAT_COST_TYPE, units: 0 },
}

export default {
  name: 'WorkflowNodeCost',
  props: {
    node: {
      type: Object,
      required: true,
    },
    nodeType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cost() {
      if (this.nodeType.isTrigger || this.nodeType.isContainer) {
        return { type: FLAT_COST_TYPE, units: 0 }
      }
      return COST_OVERRIDES[this.node.type] || DEFAULT_COST
    },
    label() {
      if (this.cost.type === TIME_BASED_COST_TYPE) {
        return this.$t('workflowNodeCost.timeBased', {
          count: this.cost.unitsPerSecond,
        })
      }

      if (this.cost.units === 0) {
        return this.$t('workflowNodeCost.free')
      }

      return this.$t('workflowNodeCost.flat', {
        count: this.cost.units,
      })
    },
  },
}
</script>
